module.exports = __webpack_public_path__ + "static/media/idex.4ed9cfd8.svg";